import { useCallback } from 'react';
import { AgentDocumentTypes } from 'types';
import styles from '../styles.module.scss';

const Container = ({ children, color }) => (
  <div
    style={{
      background: color,
    }}
    className={styles.container}
  >
    {children}
  </div>
);

export const DocumentIcons = ({ type }) => {
  const getIcon = useCallback(() => {
    switch (type) {
      case AgentDocumentTypes.Drafts:
        return (
          <Container color="#F4F5F6">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.15039 8.38162C7.15039 6.64992 8.55422 5.24609 10.2859 5.24609H17.0816C17.8977 5.24609 18.6803 5.57027 19.2573 6.1473L23.4077 10.2977C24.3769 11.2668 23.6904 12.924 22.3198 12.924H19.6925C17.9931 12.924 16.6155 11.5464 16.6155 9.84705V7.70763H10.2859C9.91369 7.70763 9.61193 8.00939 9.61193 8.38162V23.6197C9.61193 23.992 9.91369 24.2937 10.2859 24.2937L12.9232 24.2937C13.603 24.2937 14.154 24.8447 14.154 25.5245C14.154 26.2042 13.603 26.7552 12.9232 26.7552L10.2859 26.7553C8.55422 26.7553 7.15039 25.3514 7.15039 23.6197V8.38162ZM19.0771 9.4482V9.84705C19.0771 10.1869 19.3526 10.4624 19.6925 10.4624H20.0913L19.0771 9.4482Z"
                fill="#747475"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26.4633 12.1427C25.603 12.1427 24.7779 12.4845 24.1696 13.0928L15.7344 21.528C15.4459 21.8165 15.2838 22.2078 15.2838 22.6158V25.643C15.2838 26.1528 15.6971 26.5661 16.2069 26.5661H19.234C19.6421 26.5661 20.0334 26.404 20.3219 26.1154L28.757 17.6803C29.3654 17.072 29.7071 16.2469 29.7071 15.3866C29.7071 14.5262 29.3654 13.7012 28.757 13.0928C28.1487 12.4845 27.3236 12.1427 26.4633 12.1427ZM25.3584 14.823C25.1181 14.5826 24.7285 14.5826 24.4881 14.823L24.053 15.2581C23.8127 15.4984 23.8127 15.8881 24.053 16.1284L25.7189 17.7943C25.9592 18.0346 26.3489 18.0346 26.5892 17.7943L27.0243 17.3592C27.2647 17.1188 27.2647 16.7292 27.0243 16.4889L25.3584 14.823Z"
                fill="#747475"
              />
            </svg>
          </Container>
        );
      case AgentDocumentTypes.PendingForms:
        return (
          <Container color="#F4F4FB">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.6 15.9996C13.6 13.5996 10 13.5996 10 7.59961H22C22 13.5996 18.4 13.5996 18.4 15.9996C18.4 18.3996 22 18.3996 22 24.3996H10C10 18.3996 13.6 18.3996 13.6 15.9996Z"
                stroke="#928CDA"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.7998 7.59961H23.1998"
                stroke="#928CDA"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.7998 24.4004H23.1998"
                stroke="#928CDA"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M16.0001 18.4004C15.4001 18.4004 13.6001 20.2004 13.6001 22.0004H18.4001C18.4001 20.2004 16.6001 18.4004 16.0001 18.4004Z"
                fill="#928CDA"
              />
              <path
                d="M15.9998 13.5996C15.6998 13.5996 14.7998 12.9996 14.7998 12.3996H17.1998C17.1998 12.9996 16.2998 13.5996 15.9998 13.5996Z"
                fill="#928CDA"
              />
            </svg>
          </Container>
        );
      case AgentDocumentTypes.PreApprovals:
        return (
          <Container color="#00B1521A">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.6023 6.23802C14.8065 4.64982 17.1939 4.64983 18.3982 6.23802C19.0553 7.1046 20.1294 7.54924 21.2068 7.40111C23.1812 7.12991 24.8689 8.81828 24.5974 10.7927C24.4494 11.8699 24.8941 12.9433 25.7605 13.6003C27.3487 14.8046 27.3487 17.192 25.7605 18.3962C24.894 19.0533 24.4493 20.1275 24.5974 21.2048C24.8686 23.1791 23.181 24.8666 21.2068 24.5954C20.1294 24.4473 19.0553 24.892 18.3982 25.7585C17.1939 27.3467 14.8065 27.3467 13.6023 25.7585C12.9453 24.8922 11.8718 24.4475 10.7947 24.5954C8.82023 24.8669 7.13186 23.1792 7.40306 21.2048C7.5512 20.1274 7.10655 19.0533 6.23998 18.3962C4.65178 17.192 4.65178 14.8046 6.23998 13.6003C7.1064 12.9433 7.55104 11.8699 7.40306 10.7927C7.13157 8.81815 8.8201 7.12962 10.7947 7.40111C11.8719 7.54908 12.9453 7.10445 13.6023 6.23802ZM20.5359 12.3327C20.0409 11.8669 19.2625 11.8906 18.7966 12.3855L14.7429 16.6921L13.1785 15.1277C12.6978 14.647 11.9179 14.647 11.4372 15.1277C10.9568 15.6082 10.9569 16.3873 11.4372 16.8679L13.8992 19.3298C14.1345 19.5651 14.4551 19.6952 14.7878 19.6902C15.1206 19.6851 15.4376 19.5458 15.6658 19.3035L20.5886 14.072C21.0543 13.5771 21.0307 12.7986 20.5359 12.3327Z"
                fill="#00B152"
              />
            </svg>
          </Container>
        );
      case AgentDocumentTypes.MessageAttachments:
        return (
          <Container color="#EEFBF4">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.9982 11.0024L12.4982 17.5024C12.1004 17.9002 11.8769 18.4398 11.8769 19.0024C11.8769 19.565 12.1004 20.1046 12.4982 20.5024C12.8961 20.9002 13.4356 21.1237 13.9982 21.1237C14.5608 21.1237 15.1004 20.9002 15.4982 20.5024L21.9982 14.0024C22.7939 13.2068 23.2409 12.1276 23.2409 11.0024C23.2409 9.87719 22.7939 8.79806 21.9982 8.00241C21.2026 7.20676 20.1235 6.75977 18.9982 6.75977C17.873 6.75977 16.7939 7.20676 15.9982 8.00241L9.49824 14.5024C8.30476 15.6959 7.63428 17.3146 7.63428 19.0024C7.63428 20.6902 8.30476 22.3089 9.49824 23.5024C10.6917 24.6959 12.3104 25.3664 13.9982 25.3664C15.6861 25.3664 17.3048 24.6959 18.4982 23.5024L24.9982 17.0024"
                stroke="#04A451"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Container>
        );
      case AgentDocumentTypes.Transactions:
        return (
          <Container color="#7474751A">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.5016 6.1967C19.1024 5.59589 20.0765 5.59589 20.6773 6.1967L24.267 9.78644C24.8678 10.3872 24.8678 11.3613 24.267 11.9622L20.6773 15.5519C20.0765 16.1527 19.1024 16.1527 18.5016 15.5519C17.9008 14.9511 17.9008 13.977 18.5016 13.3762L19.465 12.4128H8.8202C7.97053 12.4128 7.28174 11.724 7.28174 10.8743C7.28174 10.0246 7.97053 9.33584 8.8202 9.33584H19.465L18.5016 8.37241C17.9008 7.77161 17.9008 6.79751 18.5016 6.1967Z"
                fill="#747475"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.4982 16.4515C12.8974 15.8507 11.9233 15.8507 11.3225 16.4515L7.73274 20.0413C7.13194 20.6421 7.13194 21.6162 7.73274 22.217L11.3225 25.8067C11.9233 26.4075 12.8974 26.4075 13.4982 25.8067C14.099 25.2059 14.099 24.2318 13.4982 23.631L12.5348 22.6676H23.1796C24.0292 22.6676 24.718 21.9788 24.718 21.1291C24.718 20.2794 24.0292 19.5906 23.1796 19.5906H12.5348L13.4982 18.6272C14.099 18.0264 14.099 17.0523 13.4982 16.4515Z"
                fill="#747475"
              />
            </svg>
          </Container>
        );
      case AgentDocumentTypes.Ungrouped:
        return (
          <Container color="#FFF2F3">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.8335 18.1668C14.1865 18.5271 14.6079 18.8133 15.073 19.0087C15.538 19.2041 16.0374 19.3048 16.5418 19.3048C17.0463 19.3048 17.5456 19.2041 18.0107 19.0087C18.4757 18.8133 18.8971 18.5271 19.2502 18.1668L23.5835 13.8334C24.3018 13.1151 24.7053 12.1409 24.7053 11.1251C24.7053 10.1093 24.3018 9.13505 23.5835 8.41675C22.8652 7.69846 21.891 7.29492 20.8752 7.29492C19.8593 7.29492 18.8851 7.69846 18.1668 8.41675L17.6252 8.95842"
                stroke="#FF576D"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M18.1663 13.8334C17.8132 13.4731 17.3918 13.1868 16.9268 12.9914C16.4617 12.796 15.9624 12.6953 15.4579 12.6953C14.9535 12.6953 14.4541 12.796 13.9891 12.9914C13.524 13.1868 13.1026 13.4731 12.7496 13.8334L8.41626 18.1667C7.69797 18.885 7.29443 19.8592 7.29443 20.875C7.29443 21.8909 7.69797 22.8651 8.41626 23.5834C9.13456 24.3017 10.1088 24.7052 11.1246 24.7052C12.1404 24.7052 13.1146 24.3017 13.8329 23.5834L14.3746 23.0417"
                stroke="#FF576D"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M20.3335 25.7507V23.584"
                stroke="#FF576D"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M23.5835 20.334H25.7502"
                stroke="#FF576D"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M6.25 11.666H8.41667"
                stroke="#FF576D"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.6665 6.25V8.41667"
                stroke="#FF576D"
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Container>
        );
      case AgentDocumentTypes.Misc:
        return (
          <Container color="#51BFE11A">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.519 11.8057C23.519 11.5264 23.847 11.3758 24.0591 11.5576L25.1226 12.4688C25.5572 12.8413 25.808 13.3855 25.8081 13.958V21.8828C25.8081 24.4106 23.7587 26.46 21.231 26.46H14.0386C12.9553 26.4599 12.0776 25.5813 12.0776 24.498C12.0779 24.3178 12.2235 24.172 12.4038 24.1719H20.2505C22.0559 24.1718 23.519 22.7078 23.519 20.9023V11.8057ZM16.4956 3.90234C17.2757 3.90238 18.024 4.21215 18.5757 4.76367L21.3501 7.53809C21.9019 8.08988 22.2114 8.83879 22.2114 9.61914V19.9219C22.2113 21.5467 20.8939 22.8643 19.269 22.8643H10.1157C8.49083 22.8643 7.1735 21.5467 7.17334 19.9219V6.84473C7.17334 5.21973 8.49073 3.90234 10.1157 3.90234H16.4956ZM10.9536 12.2812C10.2201 12.2812 9.62549 12.8759 9.62549 13.6094C9.62549 14.3429 10.2201 14.9375 10.9536 14.9375C11.6869 14.9372 12.2817 14.3427 12.2817 13.6094C12.2817 12.876 11.6869 12.2815 10.9536 12.2812ZM14.6724 12.2812C13.9389 12.2812 13.3442 12.8759 13.3442 13.6094C13.3442 14.3429 13.9389 14.9375 14.6724 14.9375C15.4056 14.9372 16.0005 14.3427 16.0005 13.6094C16.0005 12.876 15.4056 12.2815 14.6724 12.2812ZM18.3911 12.2812C17.6576 12.2812 17.063 12.8759 17.063 13.6094C17.063 14.3429 17.6576 14.9375 18.3911 14.9375C19.1244 14.9372 19.7192 14.3427 19.7192 13.6094C19.7192 12.876 19.1244 12.2815 18.3911 12.2812Z"
                fill="#51BFE1"
              />
            </svg>
          </Container>
        );
      case AgentDocumentTypes.OfferIteration:
        return (
          <Container color="#EEFBF4">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18.1387 5.55273C18.6434 5.55273 19.1276 5.75632 19.4805 6.11719L24.0078 10.748C24.3503 11.0984 24.5419 11.5687 24.542 12.0586V23.6191C24.5417 25.1806 23.2763 26.4461 21.7148 26.4463H10.2861C8.72452 26.4463 7.45826 25.1807 7.45801 23.6191V8.38086C7.45801 6.81909 8.72436 5.55273 10.2861 5.55273H18.1387ZM16 10.7695C15.4903 10.7695 15.0773 11.1827 15.0771 11.6924V12.1074C14.5398 12.2371 14.0753 12.4819 13.707 12.8271C13.1464 13.3528 12.8613 14.0604 12.8613 14.7695C12.8613 15.2243 12.9801 15.6381 13.2158 15.9941C13.4451 16.3404 13.7519 16.5825 14.0547 16.7568C14.373 16.9401 14.7212 17.0559 15.0771 17.1543V19.2148C14.7626 19.0804 14.4825 18.889 14.2812 18.6514C13.9561 18.2674 13.4135 18.1448 12.9893 18.459C12.5679 18.7711 12.3075 19.3854 13.0352 20.0225C13.1731 20.1622 13.374 20.3416 13.6377 20.5195C14.0567 20.8023 14.553 21.0096 15.0771 21.1299V21.5391C15.0773 22.0487 15.4903 22.4619 16 22.4619C16.5097 22.4619 16.9227 22.0487 16.9229 21.5391V21.1768C17.4703 21.0748 17.9871 20.8639 18.417 20.5254C19.0748 20.0074 19.3847 19.2648 19.3848 18.4619C19.3848 17.4598 18.8957 16.7783 18.2363 16.3467C17.8295 16.0804 17.3804 15.9306 16.9229 15.8066V14.0537C17.1596 14.1534 17.3645 14.2814 17.5 14.4297C17.8373 14.7984 18.3852 14.8928 18.792 14.5674C19.0972 14.3232 19.312 13.6754 18.8623 13.1836C18.7491 13.0598 18.5149 12.8304 18.1504 12.6025C17.8359 12.406 17.4256 12.214 16.9229 12.1016V11.6924C16.9227 11.1827 16.5097 10.7695 16 10.7695ZM16.9229 17.7207C17.0264 17.7717 17.1281 17.8278 17.2256 17.8916C17.4429 18.0339 17.5381 18.1718 17.5381 18.4619C17.5381 18.7666 17.438 18.9471 17.2754 19.0752C17.1684 19.1594 17.0493 19.2267 16.9229 19.2803V17.7207ZM15.0771 15.21C15.0435 15.1922 15.0087 15.1753 14.9756 15.1562C14.8129 15.0626 14.708 14.9637 14.708 14.7695C14.708 14.4264 14.8523 14.1918 15.0771 14.0439V15.21Z"
                fill="#00B152"
              />
            </svg>
          </Container>
        );
      case AgentDocumentTypes.ShowingAppointment:
        return (
          <Container color="#FFF4EB">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.9233 4.30664C21.6028 4.30678 22.1536 4.85767 22.1538 5.53711V5.9082H22.646C24.5492 5.9082 26.0922 7.45127 26.0923 9.35449V22.6465C26.0923 24.5497 24.5493 26.0928 22.646 26.0928H9.354C7.45076 26.0928 5.90771 24.5497 5.90771 22.6465V9.35449C5.90776 7.45128 7.45079 5.90822 9.354 5.9082H9.84619V5.53711C9.84643 4.85768 10.3972 4.3068 11.0767 4.30664C11.7562 4.30664 12.3079 4.85758 12.3081 5.53711V5.9082H19.6919V5.53711C19.6921 4.85759 20.2438 4.30666 20.9233 4.30664ZM8.36963 22.6465C8.36963 23.1903 8.81023 23.6308 9.354 23.6309H22.646C23.1898 23.6309 23.6304 23.1903 23.6304 22.6465V13.2305H8.36963V22.6465ZM18.2153 17.1074C18.8949 17.1075 19.4456 17.6583 19.4458 18.3379C19.4458 19.0176 18.895 19.5693 18.2153 19.5693H13.7847C13.1049 19.5693 12.5542 19.0176 12.5542 18.3379C12.5544 17.6583 13.105 17.1074 13.7847 17.1074H18.2153ZM12.3071 8.00195C12.3055 8.68034 11.7554 9.22949 11.0767 9.22949C10.398 9.22933 9.84777 8.68024 9.84619 8.00195C9.65367 8.25877 9.53864 8.57716 9.53857 8.92285C9.53857 9.77242 10.2271 10.4618 11.0767 10.4619C11.9263 10.4619 12.6157 9.77252 12.6157 8.92285C12.6157 8.577 12.4999 8.25883 12.3071 8.00195ZM22.1528 8.00195C22.1513 8.68025 21.602 9.22935 20.9233 9.22949C20.2446 9.22947 19.6935 8.68033 19.6919 8.00195C19.4993 8.25875 19.3843 8.57721 19.3843 8.92285C19.3843 9.77251 20.0737 10.4619 20.9233 10.4619C21.7729 10.4618 22.4614 9.77243 22.4614 8.92285C22.4614 8.57694 22.3456 8.25885 22.1528 8.00195Z"
                fill="#FB913A"
              />
            </svg>
          </Container>
        );
      case DocumentIcons.MODAL_CLOSE:
        return (
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.75"
              y="0.75"
              width="38.5"
              height="38.5"
              rx="19.25"
              fill="white"
              stroke="#E8E9EA"
              strokeWidth="1.5"
            />
            <path d="M25 25L15 15" stroke="#262626" strokeWidth="2" strokeLinecap="round" />
            <path d="M15 25L25 15" stroke="#262626" strokeWidth="2" strokeLinecap="round" />
          </svg>
        );
      case DocumentIcons.PROPERTY:
        return (
          <Container color="#FB913A1A">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.23054 26.464H6.15362C5.47389 26.464 4.92285 25.913 4.92285 25.2332V7.73873C4.92285 6.71913 5.7494 5.89258 6.76901 5.89258H17.3185C18.3381 5.89258 19.1646 6.71913 19.1646 7.73873V25.2332C19.1646 25.913 18.6136 26.464 17.9338 26.464H15.1207C14.4409 26.464 13.8899 25.913 13.8899 25.2332V23.3871C13.8899 23.0472 13.6144 22.7717 13.2745 22.7717H11.0767C10.7368 22.7717 10.4613 23.0472 10.4613 23.3871V25.2332C10.4613 25.913 9.91028 26.464 9.23054 26.464ZM9.23054 9.58489C8.89068 9.58489 8.61516 9.8604 8.61516 10.2003V11.3431C8.61516 11.683 8.89068 11.9585 9.23054 11.9585H10.3734C10.7133 11.9585 10.9888 11.683 10.9888 11.3431V10.2003C10.9888 9.8604 10.7133 9.58489 10.3734 9.58489H9.23054ZM9.23054 13.5409C8.89068 13.5409 8.61516 13.8164 8.61516 14.1563V15.2992C8.61516 15.639 8.89068 15.9146 9.23054 15.9146H10.3734C10.7133 15.9146 10.9888 15.639 10.9888 15.2992V14.1563C10.9888 13.8164 10.7133 13.5409 10.3734 13.5409H9.23054ZM8.61516 18.1124C8.61516 17.7725 8.89068 17.497 9.23054 17.497H10.3734C10.7133 17.497 10.9888 17.7725 10.9888 18.1124V19.2552C10.9888 19.5951 10.7133 19.8706 10.3734 19.8706H9.23054C8.89068 19.8706 8.61516 19.5951 8.61516 19.2552V18.1124ZM13.7141 9.58489C13.3742 9.58489 13.0987 9.8604 13.0987 10.2003V11.3431C13.0987 11.683 13.3742 11.9585 13.7141 11.9585H14.8569C15.1968 11.9585 15.4723 11.683 15.4723 11.3431V10.2003C15.4723 9.8604 15.1968 9.58489 14.8569 9.58489H13.7141ZM13.0987 14.1563C13.0987 13.8164 13.3742 13.5409 13.7141 13.5409H14.8569C15.1968 13.5409 15.4723 13.8164 15.4723 14.1563V15.2992C15.4723 15.639 15.1968 15.9146 14.8569 15.9146H13.7141C13.3742 15.9146 13.0987 15.639 13.0987 15.2992V14.1563ZM13.7141 17.497C13.3742 17.497 13.0987 17.7725 13.0987 18.1124V19.2552C13.0987 19.5951 13.3742 19.8706 13.7141 19.8706H14.8569C15.1968 19.8706 15.4723 19.5951 15.4723 19.2552V18.1124C15.4723 17.7725 15.1968 17.497 14.8569 17.497H13.7141Z"
                fill="#FB913A"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M21.9769 26.461H25.8451C26.5248 26.461 27.0758 25.9099 27.0758 25.2302V13.6676C27.0758 12.9458 26.6551 12.2901 25.9989 11.9893L21.4934 9.92433C21.144 9.7642 20.7462 10.0195 20.7462 10.4038V25.2302C20.7462 25.9099 21.2972 26.461 21.9769 26.461ZM23.4714 13.8016C23.1316 13.8016 22.8561 14.0771 22.8561 14.417V15.2961C22.8561 15.636 23.1316 15.9115 23.4714 15.9115H24.3506C24.6904 15.9115 24.9659 15.636 24.9659 15.2961V14.417C24.9659 14.0771 24.6904 13.8016 24.3506 13.8016H23.4714ZM22.8561 18.1093C22.8561 17.7695 23.1316 17.4939 23.4714 17.4939H24.3506C24.6904 17.4939 24.9659 17.7695 24.9659 18.1093V18.9884C24.9659 19.3283 24.6904 19.6038 24.3506 19.6038H23.4714C23.1316 19.6038 22.8561 19.3283 22.8561 18.9884V18.1093ZM23.4714 21.1862C23.1316 21.1862 22.8561 21.4618 22.8561 21.8016V22.6807C22.8561 23.0206 23.1316 23.2961 23.4714 23.2961H24.3506C24.6904 23.2961 24.9659 23.0206 24.9659 22.6807V21.8016C24.9659 21.4618 24.6904 21.1862 24.3506 21.1862H23.4714Z"
                fill="#FB913A"
              />
            </svg>
          </Container>
        );
      case DocumentIcons.PORTFOLIO:
        return (
          <Container color="#4673D11A">
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.29639 13.5608C5.29639 11.9828 6.57557 10.7036 8.15353 10.7036H14.353C15.2774 10.7036 16.1446 11.1508 16.6807 11.9038L17.6724 13.2971H23.8458C25.4238 13.2971 26.703 14.5763 26.703 16.1542V24.4179C26.703 25.9959 25.4238 27.275 23.8458 27.275H8.15353C6.57557 27.275 5.29639 25.9959 5.29639 24.4179V13.5608Z"
                fill="#4673D1"
              />
              <path
                d="M6.52729 7.53878C6.52729 5.96083 7.80647 4.68164 9.38443 4.68164H19.5383C21.1162 4.68164 22.3954 5.96083 22.3954 7.53878V11.3849C22.3954 11.8583 22.0117 12.2421 21.5383 12.2421H19.1426C18.8825 12.2421 18.6365 12.124 18.4738 11.921L17.1249 10.2382C16.7408 9.759 16.1551 9.48165 15.5359 9.48591C13.7901 9.49794 12.355 9.49092 10.8034 9.48332C9.75977 9.47822 8.66345 9.47285 7.38443 9.47285C6.91104 9.47285 6.52729 9.08909 6.52729 8.61571V7.53878Z"
                fill="#4673D1"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.6921 12.286V8.00028C24.651 8.00028 25.4283 8.77761 25.4283 9.7365V12.286H23.6921Z"
                fill="#4673D1"
              />
            </svg>
          </Container>
        );
      default: {
        return <></>;
      }
    }
  }, [type]);

  return getIcon();
};

DocumentIcons.MODAL_CLOSE = 'modal-close';
DocumentIcons.PROPERTY = 'property';
DocumentIcons.PORTFOLIO = 'portfolio';
